<template>
  <div class="position-relative">
    <div
      v-if="countCreatedResponse < 3"
      class="root-preloader position-absolute overlay-loader-wrapper"
    >
      <div
        class="
          spinner-bounce
          d-flex
          align-items-center
          dashboard-preloader
          justify-content-center
        "
      >
        <span class="bounce1 mr-1" />
        <span class="bounce2 mr-1" />
        <span class="bounce3 mr-1" />
        <span class="bounce4" />
      </div>
    </div>
    <div class="content-wrapper">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: baseline;
        "
      >
        <app-breadcrumb
          :page-title="$t('dashboard')"
          :directory="$t('dashboard')"
          :icon="'pie-chart'"
        />
        <el-dropdown>
          <el-button type="primary" class="btn btn-primary btn-sm">
            <app-icon name="align-right" />
            <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a href="/admin/documentlibrary/mydocument">My Documents</a></el-dropdown-item>
            <el-dropdown-item><a href="/buyer/job/myjob">My Jobs</a></el-dropdown-item>
            <el-dropdown-item><a href="/buyer/supplier/chat">Chat</a></el-dropdown-item>
            <el-dropdown-item>
              <a href="/admin/log-out"> Logout </a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <app-overlay-loader v-if="!defaultData && !mainPreloader" />
      <div class="row" v-if="defaultData">
        <div
          class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3"
          v-for="(item, index) in info.getDefaultDashboardInfo.topSectionData"
          :key="index"
        >
        <div class="cards-wrapper w-100 d-block">
          <!-- {{ item }} -->
          <a v-if="item.label != 'New Suppliers'" :href="item.url" target="_blank" style="color:#000">
            <app-widget
              class="mb-primary"
              :type="'app-widget-with-icon'"
              :label="item.label"
              :number="item.number"
              :icon="item.icon"
            />
          </a>
          <a v-else @click.prevent="openModal()" class="cursor-pointer" style="color:#000">
            <app-widget
              class="mb-primary"
              :type="'app-widget-with-icon'"
              :label="item.label"
              :number="item.number"
              :icon="item.icon"
            />
          </a>
        </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-12 mb-primary">
          <!-- <app-overlay-loader v-if="!audienceChart && !mainPreloader" /> -->
          <div
            class="card card-with-shadow border-0 h-100"
            v-if="audienceChart"
          >
            <div
              class="
                card-header
                bg-transparent
                p-primary
                d-flex
                justify-content-between
                align-items-center
              "
            >
              <h5 class="card-title mb-0">{{ $t("audience_overview") }}</h5>
              <ul class="nav tab-filter-menu justify-content-flex-end">
                <li
                  class="nav-item"
                  v-for="(item, index) in info.audienceOverviewChart
                    .chartFilterOptions"
                  :key="index"
                >
                  <a
                    href="#"
                    class="nav-link py-0"
                    :class="[
                      audienceFilter == item.id
                        ? 'active'
                        : index === 0 && audienceFilter === ''
                        ? 'active'
                        : '',
                    ]"
                    @click.prevent="audienceOverviewCartFilterValue(item.id)"
                  >
                    {{ item.value }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="card-body">
              <app-chart
                class="mb-primary"
                type="custom-line-chart"
                :height="170"
                :labels="info.audienceOverviewChart.labels"
                :data-sets="info.audienceOverviewChart.chartData"
              />
              <div
                class="chart-data-list d-flex flex-wrap justify-content-center"
              >
                <div class="data-group-item" style="color: #368cd5">
                  <span class="square" style="background-color: #368cd5" />
                  {{ $t("Buyer") }}

                  <span class="value">{{
                    info.audienceOverviewChart.user
                  }}</span>
                </div>
                <div class="data-group-item" style="color: #f7531e">
                  <span class="square" style="background-color: #f7531e" />
                  {{ $t("Supplier") }}

                  <span class="value">{{
                    info.audienceOverviewChart.visitor
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-overlay-loader v-if="!defaultData && !mainPreloader" />
        <!-- <div class="col-12 col-md-3 mb-4 mb-md-0" v-if="defaultData">
          <div
            :class="{
              'mb-primary':
                index !==
                info.getDefaultDashboardInfo.circleTopSection.length - 1,
            }"
            v-for="(item, index) in info.getDefaultDashboardInfo
              .circleTopSection"
            :key="index"
          >
            <app-widget
              :type="'app-widget-with-circle'"
              :label="item.label"
              :number="item.number"
            />
          </div>
        </div> -->
      </div>
      <div class="flex flex-column mb-5 mt-4 faq-section">
        <div class="row">
          <div class="col-md-12">
            <div id="accordion">
              <div class="card">
                <div class="card-header" id="heading-1">
                  <h5 class="mb-0">
                    <a role="button" class="heading-style" data-toggle="collapse" href="#collapse-1" aria-expanded="true" aria-controls="collapse-1">
                      Tasks</a>
                  </h5>
                </div>
                <div id="collapse-1" class="collapse show" data-parent="#accordion" aria-labelledby="heading-1">
                  <div class="card-body">
                    <app-overlay-loader v-if="!defaultData && !mainPreloader" />
                    <div class="row" v-if="defaultData">
                      <div
                        class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3"
                        v-for="(item, index) in info.getDefaultDashboardInfo
                          .taskSectionData"
                        :key="index"
                      >
                        <div class="cards-wrapper w-100 d-block">
                          <a :href="item.url" target="_blank" style="color:#000">
                            <app-widget
                              class="mb-primary"
                              :type="'app-widget-with-icon'"
                              :label="item.label"
                              :number="item.number"
                              :icon="item.icon"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="heading-2">
                  <h5 class="mb-0">
                    <a class="collapsed heading-style" role="button" data-toggle="collapse" href="#collapse-2" aria-expanded="false" aria-controls="collapse-2">
                      Jobs</a>
                  </h5>
                </div>
                <div id="collapse-2" class="collapse" data-parent="#accordion" aria-labelledby="heading-2">
                  <div class="card-body">
                    <app-overlay-loader v-if="!defaultData && !mainPreloader" />
                      <div class="row" v-if="defaultData">
                        <div
                          class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3"
                          v-for="(item, index) in info.getDefaultDashboardInfo
                            .topSectionData"
                          :key="index"
                        >
                          <div class="cards-wrapper w-100 d-block">
                            <a :href="item.url" target="_blank" style="color:#000">
                              <app-widget
                                class="mb-primary"
                                :type="'app-widget-with-icon'"
                                :label="item.label"
                                :number="item.number"
                                :icon="item.icon"
                              />
                            </a>
                          </div>
                        </div>
                      </div>                  
                  </div>
                </div>
              </div>
              
            </div>
          </div>
          
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-12">
          <app-overlay-loader v-if="!defaultData && !mainPreloader" />
          <div class="row" v-if="defaultData">
            <div
              class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3"
              v-for="(item, index) in info.getDefaultDashboardInfo
                .bottomSectionData"
              :key="index"
            >
              <div class="cards-wrapper w-100 d-block">
                <a :href="item.url" target="_blank" style="color:#000">
                  <app-widget
                    class="mb-primary"
                    :type="'app-widget-with-icon'"
                    :label="item.label"
                    :number="item.number"
                    :icon="item.icon"
                  />
                </a>
              </div>
            </div>
          </div>

          <!-- <div class="row" v-if="defaultData">
            <div
              class="col-12 col-md-6 mb-4 mb-md-0"
              v-for="(item, index) in info.getDefaultDashboardInfo
                .circleBottomSection"
              :key="index"
            >
              <app-widget
                :type="'app-widget-with-circle'"
                :label="item.label"
                :number="item.number"
              />
            </div>
          </div> -->
        </div>

        <!-- <div class="col-12 col-md-6">
          <app-overlay-loader v-if="!browserChart && !mainPreloader" />
          <div class="card card-with-shadow border-0 h-100" v-if="browserChart">
            <div
              class="
                card-header
                bg-transparent
                p-primary
                d-flex
                justify-content-between
                align-items-center
              "
            >
              <h5 class="card-title mb-0">{{ $t("browser_overview") }}</h5>
              <ul class="nav tab-filter-menu justify-content-flex-end">
                <li
                  class="nav-item"
                  v-for="(item, index) in info.browserOverviewChart
                    .chartFilterOptions"
                  :key="index"
                >
                  <a
                    href="#"
                    class="nav-link py-0"
                    :class="[
                      browserFilter == item.id
                        ? 'active'
                        : index === 0 && browserFilter === ''
                        ? 'active'
                        : '',
                    ]"
                    @click.prevent="browserOverviewChartFilterValue(item.id)"
                  >
                    {{ item.value }}
                  </a>
                </li>
              </ul>
            </div>
            <div class="card-body">
              <app-chart
                class="mb-primary"
                type="line-chart"
                :height="210"
                :labels="info.browserOverviewChart.labels"
                :data-sets="info.browserOverviewChart.chartData"
              />
              <div
                class="chart-data-list d-flex flex-wrap justify-content-center"
              >
                <div class="data-group-item" style="color: rgb(3, 90, 166)">
                  <span
                    class="square"
                    style="background-color: rgb(3, 90, 166)"
                  />
                  {{ $t("chrome") }}
                  <span class="value"
                    >{{ info.browserOverviewChart.chrome }}
                  </span>
                </div>
                <div class="data-group-item" style="color: rgb(64, 186, 213)">
                  <span
                    class="square"
                    style="background-color: rgb(64, 186, 213)"
                  />
                  {{ $t("firefox") }}
                  <span class="value">{{
                    info.browserOverviewChart.firefox
                  }}</span>
                </div>
                <div
                  class="data-group-item"
                  style="color: rgba(41, 199, 172, 0.7)"
                >
                  <span
                    class="square"
                    style="background-color: rgba(41, 199, 172, 0.7)"
                  />
                  {{ $t("opera") }}
                  <span class="value">{{
                    info.browserOverviewChart.opera
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <new-suppler-list-modal
      v-if="isModalActive"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { DashboardPreloader } from "./Mixins/DashboardPreloader";
import * as actions from "../../../../Config/ApiUrl";
import { numberFormatter } from "../../../../Helpers/Helpers";
import { axiosGet } from "../../../../Helpers/AxiosHelper";

export default {
  mixins: [FormMixin, DashboardPreloader],
  name: "Dashboard",
  data() {
    return {
      /* Loader section and active/inactive section */
      mainPreloader: true,
      isModalActive: false,
      audienceChart: false,
      browserChart: false,
      defaultData: false,
      /* end */

      audienceFilter: "this_week",
      browserFilter: "this_week",
      info: {},
    };
  },
  created() {
    this.mainPreloader = true;
    this.getDefaultDashboardInfo();
    this.audienceOverviewCart();
    this.browserOverviewCart();
  },
  methods: {
    openModal() {
      this.isModalActive = true;
    },
    closeModal() {
      $("#new-supplier-list").modal("hide");
      this.isModalActive = false;
    },
    audienceOverviewCartFilterValue(item) {
      this.audienceFilter = item;
      this.audienceChart = false;
      this.audienceOverviewCart();
    },
    browserOverviewChartFilterValue(item) {
      this.browserFilter = item;
      this.browserChart = false;
      this.browserOverviewCart();
    },

    getDefaultDashboardInfo() {
      let url = actions.DEFAULT_DASHBOARD_INFO;

      this.axiosGet(url)
        .then((response) => {
          this.info.getDefaultDashboardInfo = response.data;
          this.defaultData = true;
        })
        .catch(({ response }) => {})
        .finally(() => {
          this.mainPreloader = false;
          this.countCreatedResponse++;
        });
    },

    audienceOverviewCart() {
      let url = actions.AUDIENCE_OVERVIEW_CHART,
        reqData = {};

      reqData.params = {
        key: this.audienceFilter,
      };

      this.axiosGet(url, reqData)
        .then((response) => {
          this.info.audienceOverviewChart = response.data;
          this.audienceChart = true;
        })
        .catch(({ response }) => {})
        .finally(() => {
          this.mainPreloader = false;
          this.countCreatedResponse++;
        });
    },

    browserOverviewCart() {
      let url = actions.BROWSER_OVERVIEW_CHART,
        reqData = {};

      reqData.params = {
        key: this.browserFilter,
      };

      this.axiosGet(url, reqData)
        .then((response) => {
          this.info.browserOverviewChart = response.data;
          this.browserChart = true;
          
        })
        .catch(({ response }) => {})
        .finally(() => {
          this.mainPreloader = false;
          this.countCreatedResponse++;
        });
    },

    numberFormat(value) {
      return numberFormatter(value);
    },
    userVerified() {
      axiosGet(actions.USER_VERIFIED)
        .then((res) => {
          if (res.data.status == "warning") {
            this.$toastr.w(res.data.message);
          }
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.userVerified();
  },
};
</script>
<style>
.heading-style {
  color: #292f4c !important;
}
.faq-section .mb-0 > a {
  display: block;
  position: relative;
}

.faq-section .mb-0 > a:after {
  content: "\f067";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  right: 0;
  font-weight: 600;
}

.faq-section .mb-0 > a[aria-expanded="true"]:after {
  content: "\f068";
  font-family: "Font Awesome 5 Free";
  font-weight: 600;
}
</style>
